'use client';

import React, { useEffect, useMemo } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { useAuth } from 'src/context/auth';
import { useSelector, useDispatch } from 'react-redux';
import { selectDiscoveryMapCurrentTerritory, setCurrentTerritory } from 'src/redux/slices/discoveryMapSlice';
import { useDrawer } from 'src/hooks/drawers/useDrawer';

const TerritoryPanel = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const currentTerritory = useSelector(selectDiscoveryMapCurrentTerritory);
  const { openDrawer } = useDrawer();

  useEffect(() => {
    if (user && !currentTerritory) {
      dispatch(setCurrentTerritory(user.last_territory || null));
    }
  }, [user]);

  const handleOpenDrawer = () => {
    openDrawer('discovery-territory-drawer');
  };

  const showUserName = useMemo(() => {
    if (!currentTerritory || !user) return null;

    return currentTerritory.owner.id !== user.id;
  }, [currentTerritory, user]);

  return (
    <div>
      <div className="min-w-36 w-full flex-shrink-0 inline-flex flex-col justify-start items-end gap-1 relative">
        <div
          className="w-full px-4 h-9 bg-white cursor-pointer hover:bg-neutral-100 rounded-full outline outline-1
                -outline-offset-1 outline-neutral-300 inline-flex justify-between items-center"
          onClick={handleOpenDrawer}
          data-testid="territory-panel-button"
          aria-haspopup="true"
          aria-controls="discovery-territory-drawer"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleOpenDrawer();
            }
          }}
        >
          <div className="flex items-center overflow-hidden">
            <div className="max-w-40 text-secondary text-base font-normal font-['Inter'] leading-normal whitespace-nowrap truncate flex items-center gap-2">
              <Icon
                icon={faMapLocationDot}
                className="w-4 h-4 text-secondary"
              />
              {currentTerritory ? (
                <div className="flex items-center text-sm font-semibold font-['Inter'] leading-none flex-1 min-w-0 gap-1.5">
                  <span
                    className={`truncate overflow-hidden shrink-0 ${
                      currentTerritory.is_canonical
                        ? 'text-sky-600'
                        : 'text-primary'
                    }`}
                  >
                    {currentTerritory.name}
                  </span>
                  {showUserName && (
                    <>
                      <span className="text-primary shrink-0 mx-1">/</span>
                      <span className="whitespace-nowrap truncate overflow-hidden text-primary">
                        {`${currentTerritory.owner.first_name} ${currentTerritory.owner.last_name}`}
                      </span>
                    </>
                  )}
                </div>
              ) : (
                <span className="text-sm text-neutral-600 flex-1">
                  Map Without Territory
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerritoryPanel;
